var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[(_vm.$route.meta.layout == 'full')?[_c('transition',[_c('keep-alive',[_c('router-view')],1)],1)]:_c('layout-principal2')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }